import { useTranslation } from "react-i18next";
import { BankCardIcon, BucketIcon, CashIcon } from "@/shared/icons";
import Button from "@/shared/ui/button/Button";

type Props = {
  handleClear: () => void;
  onBuyCash: () => void;
  onBuyCard: () => void;
  isBuying: boolean;
};

export default function ShopCartButtons({ handleClear, onBuyCash, onBuyCard, isBuying }: Props) {
  const { t } = useTranslation("shop");

  return (
    <div className="flex gap-2">
      <Button className="grow h-11 rounded-xl" loading={isBuying} onClick={onBuyCash}>
        <span className="flex items-center gap-2.5 text-12 uppercase leading-none">
          <CashIcon className="size-5.5" />
          {t("cart.purchaseType.cash")}
        </span>
      </Button>

      <Button
        className="grow h-11 rounded-xl"
        variant="solid-surface-gradient"
        loading={isBuying}
        onClick={onBuyCard}
      >
        <span className="flex items-center gap-2.5 text-12 uppercase leading-none">
          <BankCardIcon className="size-5.5" />
          {t("cart.purchaseType.card")}
        </span>
      </Button>

      <Button
        className="group relative ml-0.5 px-6.5 h-11 bg-dark-800 rounded-xl"
        onClick={handleClear}
        variant="soft"
      >
        <span className="absolute size-full top-0 left-0 bg-gradient-accent rounded-xl opacity-0 transition-all ease-in-out duration-300 group-hover:opacity-100" />
        <span className="relative z-1 flex items-center gap-2.5 text-12 uppercase leading-none">
          <BucketIcon className="size-4.5" />
          {t("cart.clearCart")}
        </span>
      </Button>
    </div>
  );
}
